"use client";

import React from "react";
import ModalComponentSelectionMCMExample from "@/examples/modals/ModalComponentSelectionMCMExample";

export default function ModalComponentSelectionPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalComponentSelectionMCMExample />
    </div>
  );
}
